export default __webpack_public_path__ + "static/media/image-ph-study-main-2-n-w@3x.d5190fe4.png";